import emailjs from "@emailjs/browser";

// Initialize EmailJS with your public key
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

export const sendBookingEmail = async (name, email, message) => {
  try {
    const templateParams = {
      from_name: name,
      from_email: email,
      to_email: "phillip@steelbladephotography.com",
      subject: "New Booking Request - Steelblade Photography",
      message: message,
      reply_to: email,
      time:
        new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
    };

    const result = await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams
    );

    console.log("Email sent successfully:", result);
    return { success: true, data: result };
  } catch (error) {
    console.error("Email send error:", error);
    return { success: false, error };
  }
};
